const initialState = {
  brand: [],
  brandById: [],
  tableLoading: false,
  sidebarLoading: false,
  total: 0,
  modalDeleteData: {
    emableModel: false,
    message: "",
    enableCancleButton: true,
    enableOkButton: true,
    headerMsg: "",
  },
  modalData: {
    emableModel: false,
    message: "",
    displayMsg: "",
    enableCancelButton: true,
    enableOkButton: true,
    headerMsg: "",
  },
};

const BrandingReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case "GET_BRAND":
      return {
        ...state,
        brand: payload || [],
      };
    case "GET_BRANDING_BY_ID":
      return {
        ...state,
        brandById: payload || [],
      };
    case "SAVE_BRAND":
      return {
        ...state,
        brand: [...state.brand, payload],
        total: state.total + 1,
      };
    case "UPDATE_BRAND":
      return {
        ...state,
        brandById: state.brand.map((b) => {
          return b.id === payload.id ? payload : b;
        }),
      };
    case "OPEN_MODEL":
      return {
        ...state,
        modalData: action.value,
      };
    case "DELETE_BRAND":
      return {
        ...state,
        brand: state.brand.filter(({ id }) => id !== payload),
      };
    case "OPEN_MODEL_DELETE":
      return {
        ...state,
        modalDeleteData: payload,
      };
    case "SET_TABLE_LOADING":
      return {
        ...state,
        tableLoading: payload,
      };
    case "SET_SIDEBAR_LOADING":
      return {
        ...state,
        sidebarLoading: payload,
      };
    default:
      return state;
  }
};

export default BrandingReducer;
